// assets/custom-cart-validation.js

document.addEventListener('DOMContentLoaded', function() {
  // Función para obtener el contenido del carrito
  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  // Función para verificar si un producto está en el carrito
  function isProductInCart(cart, productHandle) {
    return cart.items.some(item => item.handle === productHandle);
  }

  // Función para obtener la cantidad de un producto en el carrito
  function getProductQuantity(cart, productHandle) {
    const item = cart.items.find(item => item.handle === productHandle);
    return item ? item.quantity : 0;
  }

  // Función para verificar si hay algún aceite en el carrito
  function hasOilInCart(cart) {
    return isProductInCart(cart, 'el-mil-02-olive-oil') || isProductInCart(cart, 'el-verd');
  }

  // Handles de los tres productos principales
  const mainProductHandles = ['carmen-del-poaig', 'el-mil-02-olive-oil', 'el-verd'];

  // Escuchar el evento 'submit' en el formulario 'Agregar al carrito'
  const productForm = document.querySelector('form[action^="/cart/add"]');

  if (productForm) {
    productForm.addEventListener('submit', function(event) {
      // Prevenir el envío inmediato del formulario
      event.preventDefault();

      // Obtener el producto que se está agregando
      const productHandle = "{{ product.handle }}";
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const quantityToAdd = quantityInput ? parseInt(quantityInput.value) : 1;

      // Obtener el contenido del carrito
      getCart().then(cart => {
        // Lógica para 'EL VERD DEL POAIG'
        if (productHandle === 'el-verd') {
          const milInCart = isProductInCart(cart, 'el-mil-02-olive-oil');
          const verdQuantityInCart = getProductQuantity(cart, 'el-verd');
          const totalVerdQuantity = verdQuantityInCart + quantityToAdd;

          if (!milInCart && totalVerdQuantity < 2) {
            alert('Debes comprar al menos 2 unidades de EL VERD DEL POAIG sin comprar EL MIL DEL POAIG.\nYou must purchase at least 2 units of EL VERD DEL POAIG without buying EL MIL DEL POAIG.');
            return;
          }
        }

        // Lógica para 'CARMEN DEL POAIG'
        if (productHandle === 'carmen-del-poaig') {
          const milInCart = isProductInCart(cart, 'el-mil-02-olive-oil');
          const verdQuantityInCart = getProductQuantity(cart, 'el-verd');
          const totalVerdQuantity = verdQuantityInCart;

          // Si el usuario también está agregando 'EL VERD DEL POAIG' en este momento
          if ("{{ product.handle }}" === 'el-verd') {
            const verdQuantityInput = document.querySelector('input[name="quantity"]');
            const verdQuantityToAdd = verdQuantityInput ? parseInt(verdQuantityInput.value) : 0;
            totalVerdQuantity += verdQuantityToAdd;
          }

          if (!milInCart && totalVerdQuantity < 2) {
            const carmenQuantityInCart = getProductQuantity(cart, 'carmen-del-poaig');
            const totalCarmenQuantity = carmenQuantityInCart + quantityToAdd;

            if (totalCarmenQuantity < 6) {
              alert('Debes comprar al menos 6 unidades de CARMEN DEL POAIG sin comprar EL MIL DEL POAIG o 2 botellas de EL VERD DEL POAIG.\nYou must purchase at least 6 units of CARMEN DEL POAIG without buying EL MIL DEL POAIG or 2 bottles of EL VERD DEL POAIG.');
              return;
            }
          }
        }

        // Lógica para UPSELLINGS
        // Los UPSELLINGS son todos los productos excepto los tres principales
        const isUpsellingProduct = !mainProductHandles.includes(productHandle);

        if (isUpsellingProduct && !hasOilInCart(cart)) {
          alert('No puedes comprar este producto sin comprar aceite.\nYou cannot purchase this product without buying oil.');
          return;
        }

        // Si todas las validaciones pasan, enviar el formulario
        productForm.submit();
      }).catch(error => {
        console.error('Error al obtener el carrito:', error);
        // En caso de error, permitir que el formulario se envíe
        productForm.submit();
      });
    });
  }
});
